import { IAddUpdateConvenioRequest } from "../../../../model/admin-portal/request/add-update-convenio-request";
import { IConvenioResponse } from "../../../../model/admin-portal/response/convenio-response";
import { IOrgaoResponse } from "../../../../model/admin-portal/response/orgao-response";
import { ISituacaoConvenioResponse } from "../../../../model/admin-portal/response/situacao-convenio-response";
import { ITermPaggedRequest } from "../../../../model/admin-portal/request/term-pagged-request";
import { PaginationResponse } from "../../../../model/base/response/pagination-response";

export type ConveniosState = {
    dataPaginatedListResponse: PaginationResponse<IConvenioResponse>;
    isLoadingData: boolean;
    dataResponse: IConvenioResponse | null;
    dataRequest: IAddUpdateConvenioRequest;
    showAddEdit: boolean;
    dataSearchRequest: ITermPaggedRequest;
    orgaosList: IOrgaoResponse[];
    situacoesList: ISituacaoConvenioResponse[];
};

export const initialDataRequest: IAddUpdateConvenioRequest = {
    id: null,
    idOrgao: null,
    idSituacaoConvenio: null,
    numeroConvenio: '',
    nomConcedente: '',
    nomConvenente: '',
    textoObjetoConvenio: '',
    textoJustificativaConvenio: '',
    valorConvenio: 0,
    valorContrapartida: null,
    valorRepassado: 0,
    dtaCelebracao: '',
    dtaInicioVigencia: '',
    dtaFimVigencia: '',
    dtaPublicacao: '',
    documentos: []
};

export const initialState: ConveniosState = {
    dataPaginatedListResponse: new PaginationResponse<IConvenioResponse>(),
    isLoadingData: false,
    dataResponse: null,
    dataRequest: initialDataRequest,
    showAddEdit: false,
    dataSearchRequest: { page: 0, pageSize: 10, term: '' },
    orgaosList: [],
    situacoesList: []
};

export enum ACTION_TYPES {
    setDataPaginatedListResponse = 'setDataPaginatedListResponse',
    setIsLoadingData = 'setIsLoadingData',
    setDataResponse = 'setDataResponse',
    setDataRequest = 'setDataRequest',
    setShowAddEdit = 'setShowAddEdit',
    setDataSearchRequest = 'setDataSearchRequest',
    setOrgaosList = 'setOrgaosList',
    setSituacoesList = 'setSituacoesList'
}

type Action =
    | { type: ACTION_TYPES.setDataPaginatedListResponse; payload: PaginationResponse<IConvenioResponse> }
    | { type: ACTION_TYPES.setIsLoadingData; payload: boolean }
    | { type: ACTION_TYPES.setDataResponse; payload: IConvenioResponse | null }
    | { type: ACTION_TYPES.setDataRequest; payload: IAddUpdateConvenioRequest }
    | { type: ACTION_TYPES.setShowAddEdit; payload: boolean }
    | { type: ACTION_TYPES.setDataSearchRequest; payload: ITermPaggedRequest }
    | { type: ACTION_TYPES.setOrgaosList; payload: IOrgaoResponse[] }
    | { type: ACTION_TYPES.setSituacoesList; payload: ISituacaoConvenioResponse[] };

export const conveniosReducer = (state: ConveniosState, action: Action): ConveniosState => {
    switch (action.type) {
        case ACTION_TYPES.setDataPaginatedListResponse:
            return { ...state, dataPaginatedListResponse: action.payload };
        case ACTION_TYPES.setIsLoadingData:
            return { ...state, isLoadingData: action.payload };
        case ACTION_TYPES.setDataResponse:
            return { ...state, dataResponse: action.payload };
        case ACTION_TYPES.setDataRequest:
            return { ...state, dataRequest: action.payload };
        case ACTION_TYPES.setShowAddEdit:
            return { ...state, showAddEdit: action.payload };
        case ACTION_TYPES.setDataSearchRequest:
            return { ...state, dataSearchRequest: action.payload };
        case ACTION_TYPES.setOrgaosList:
            return { ...state, orgaosList: action.payload };
        case ACTION_TYPES.setSituacoesList:
            return { ...state, situacoesList: action.payload };
        default:
            return state;
    }
};
